import React, { useState } from 'react';
import { Bell, Cloud, ChevronRight, Home, Zap, ShoppingCart, User, Grid, Store, Zap as UtilityIcon, Wallet, Sun, LifeBuoy, CheckCircle } from 'lucide-react';

import ActiveApplicationsImg from '../../assets/dashboard/webpage.svg'
import MarketplaceImg from '../../assets/dashboard/buy 1.svg'
import UtilitiesImg from '../../assets/dashboard/utilities.svg'
import WalletImg from '../../assets/dashboard/wallet.svg'

// <---------------------///----------------->
import MeterImg from '../../assets/dashboard/Group 720.svg'
import SolarProductImg from '../../assets/dashboard/Group 721.svg'
import SupportImg from '../../assets/dashboard/Group 725.svg'
import ViewProductImg from '../../assets/dashboard/Group 723.svg'

import BillImg from '../../assets/dashboard/Ellipse 941.svg'
import MAIN_ILLUSTRATION  from '../../assets/dashboard/Frame.svg'
import copytag from '../../assets/dashboard/document-copy.svg'

// --- Placeholder Assets ---
const USER_AVATAR = 'https://placehold.co/80x80/2563EB/ffffff?text=U';

// Inline component for the Prepaid Meter Icon (simplified grid)
const PrepaidMeterIcon = ({ className }) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="12" x2="12" y1="4" y2="22" />
        <line x1="3" x2="21" y1="11" y2="11" />
        <circle cx="8" cy="7.5" r="1.5" fill="currentColor" />
        <circle cx="16" cy="16.5" r="1.5" fill="currentColor" />
    </svg>
);

// Inline component for the Topup Icon (K logo simulation)
const TopupIcon = ({ icon }) => (
    <div className={`w-8 h-8 rounded-full flex items-center justify-center  font-bold`}>
        <img src={icon} alt="BillIcon" />
    </div>
);


// --- Quick Access Item Component ---
const QuickAccessItem = ({ icon, label,onClick }) => (

    <button className="flex flex-col items-center w-1/4 p-2 sm:p-4" onClick={onClick}>
        <div className={` mb-2 rounded-full shadow-lg transition-transform hover:scale-105`} >
            <img
                src={icon}
                alt={label}
                className="w-8 h-8 object-contain"
            />
        </div>
        
        <div className=" mt-1">
            <p className='text-xs  font-medium text-gray-700'>{label}</p>
        </div>
    </button>
);


const MainActionItem = ({ icon, label, colorClass, bgColorClass ,onClick}) => (
    <button className="flex flex-col items-center w-1/4 p-2 sm:p-4">
        <div className={` mb-2 rounded-full ${bgColorClass} shadow-lg transition-transform hover:scale-105`} onClick={onClick}>
            <img
                src={icon}
                alt={label}
                className="w-full h-full object-contain"
            />
        </div>
        <span className="text-xs text-center font-medium text-gray-700 mt-1">
            {label}
        </span>
    </button>
);



// --- Main App Component ---
const HomeApp = ({setActiveScreen}) => {
    // Mock data for recent topups
    const handleApplyForMeter = () => {
        setActiveScreen('meter_application');
    };


       const handleActiveApplications = () => {
        setActiveScreen('active_application');
    };


        const handleMarketplace = () => {
        setActiveScreen('orders');
    };

    
        const handleUtility = () => {
        setActiveScreen('payment');
    };




    const recentTopups = [
        { id: 1, amount: '150 kWh', date: '10 Oct 2025', cost: '25,000', status: 'Successful' },
        { id: 2, amount: '80 kWh', date: '01 Oct 2025', cost: '15,000', status: 'Successful' },
    ];

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col font-sans">

            {/* --- Top Blue Header Section --- */}
            <header className="bg-blue-600/10 pt-4 pb-32 rounded-b-[40px] relative overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-indigo-100 opacity-70" />

                {/* Main Illustration Background */}
                <div className="absolute top-8 left-1/2 transform -translate-x-1/2 w-full max-w-lg h-60">
                    <img
                        src={MAIN_ILLUSTRATION}
                        alt=""
                        className="w-full h-full object-contain"
                    />
                </div>

                <div className="relative z-10 max-w-md mx-auto px-4">
                    {/* Header Row: Avatar, Title, Notification */}
                    <div className="flex justify-between items-center mb-6 pt-2">
                        <img
                            src={USER_AVATAR}
                            alt="User Avatar"
                            className="w-12 h-12 rounded-full border-2 border-white shadow-md object-cover"
                        />
                        <button className="p-2 rounded-full bg-white/30 text-white shadow-lg backdrop-blur-sm hover:bg-white/50 transition-colors">
                            <Bell className="w-6 h-6" />
                        </button>
                    </div>
                </div>
            </header>

            {/* --- Content Below Header --- */}
            <main className="flex-1 -mt-[60px] relative z-20 max-w-md w-full mx-auto px-4">

                {/* 1. Prepaid Meter Card */}
                <div className="bg-white p-6 rounded-2xl shadow-xl mb-6">
                    <div className="flex justify-between items-center mb-4">
                        <span className="text-md font-semibold text-[#000000]">Prepaid Meter</span>
                        <div className="flex items-center space-x-2">
                            <span className="text-sm font-medium text-[#1D6BE9]">02010235678991</span>
                            <img src={copytag} className="w-4 h-4 text-blue-500" />
                        </div>
                    </div>
                    <div className="mt-4">
                        <p className="text-sm font-400 text-[#6D6E72]">Available Units</p>
                        <p className="text-3xl font-extrabold text-gray-900 mt-1">258.65 <span className="text-xl font-semibold text-blue-600">kWh</span></p>
                    </div>
                </div>

                {/* 2. Quick Access Icons */}
                <div className="bg-white p-4 rounded-2xl shadow-xl mb-6">
                    <h2 className="text-md font-bold text-gray-800 mb-4">Quick Access</h2>
                    <div className="flex justify-around">
                        {/* <QuickAccessItem icon={ActiveApplicationsImg} label="Active applications" /> */}
                        <QuickAccessItem icon={MarketplaceImg} label="Marketplace" onClick={handleMarketplace}/>
                        <QuickAccessItem icon={UtilitiesImg} label="Utilities quick-pay" onClick={handleUtility} />
                        {/* <QuickAccessItem icon={WalletImg} label="Wallet" /> */}
                    </div>
                </div>

                {/* 3. Main Action Panel (Draggable/Scrollable simulation) */}
                <div className="bg-white p-6 rounded-t-3xl shadow-2xl mt-4">

                    {/* Handle/Separator */}
                    <div className="flex justify-center mb-4">
                        <div className="w-12 h-1 bg-gray-200 rounded-full"></div>
                    </div>

                    <div className="flex justify-around mb-6">
                        {/* <MainActionItem 
                            icon={PrepaidMeterIcon} 
                            label="Apply for meter" 
                            colorClass="text-blue-700"
                            bgColorClass="bg-blue-100"
                        />
                        <MainActionItem 
                            icon={Sun} 
                            label="Buy solar product" 
                            colorClass="text-yellow-700"
                            bgColorClass="bg-yellow-100"
                        />
                        <MainActionItem 
                            icon={LifeBuoy} 
                            label="Support & Issue" 
                            colorClass="text-indigo-700"
                            bgColorClass="bg-indigo-100"
                        />
                        <MainActionItem 
                            icon={CheckCircle} 
                            label="View past orders" 
                            colorClass="text-green-700"
                            bgColorClass="bg-green-100"
                        /> */}
                        <MainActionItem
                            icon={MeterImg}
                            label="Apply for meter"
                           onClick={handleApplyForMeter}

                        />

                        {/* <MainActionItem
                            icon={SolarProductImg}
                            label="Buy solar product"

                        />

                        <MainActionItem
                            icon={SupportImg}
                            label="Support & Issue"

                        /> */}

                        <MainActionItem
                            icon={ViewProductImg}
                            label="View past orders"

                        />

                    </div>

                    {/* Recent Topups Section */}
                    <div className="flex justify-between items-center mt-4 mb-4">
                        <h2 className="text-lg font-bold text-gray-800">Recent Topups</h2>
                        <button className="text-blue-600 text-sm font-semibold hover:text-blue-800 transition-colors">
                            See all
                        </button>
                    </div>

                    {/* Topup List */}
                    <div className="space-y-4">
                        {recentTopups.map(topup => (
                            <div key={topup.id} className="flex items-center justify-between p-3 bg-white rounded-xl border border-gray-100 shadow-sm">
                                <div className="flex items-center space-x-4">
                                    <TopupIcon icon={BillImg} />
                                    <div>
                                        <p className="font-semibold text-gray-800">{topup.amount}</p>
                                        <p className="text-xs text-gray-500">{topup.date}</p>
                                    </div>
                                </div>
                                <div className="text-right">
                                    <p className="font-bold text-red-600">
                                        -NGN{topup.cost}
                                    </p>
                                    <p className="text-xs font-medium text-green-600">
                                        {topup.status}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Spacer for bottom navigation */}
                    <div className="h-20"></div>

                </div>
            </main>

            {/* --- Bottom Navigation Bar --- */}
            {/* <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-2xl p-3 z-30 max-w-md mx-auto rounded-t-2xl">
                <div className="flex justify-around items-center h-full">
                    <div className="flex flex-col items-center text-blue-600 font-semibold text-xs">
                        <Home className="w-6 h-6 fill-blue-600" />
                        <span className="mt-1">Home</span>
                    </div>
                    <div className="flex flex-col items-center text-gray-500 hover:text-blue-600 transition-colors">
                        <Zap className="w-6 h-6" />
                        <span className="mt-1">Payment</span>
                    </div>
                    <div className="flex flex-col items-center text-gray-500 hover:text-blue-600 transition-colors">
                        <ShoppingCart className="w-6 h-6" />
                        <span className="mt-1">Orders</span>
                    </div>
                    <div className="flex flex-col items-center text-gray-500 hover:text-blue-600 transition-colors">
                        <User className="w-6 h-6" />
                        <span className="mt-1">Profile</span>
                    </div>
                </div>
            </nav> */}

        </div>
    );
};

export default HomeApp;